export default __webpack_public_path__ + "static/media/user_profile_dark.79e58237.svg";